import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { PgProfileEditorService } from '../pg-profile-editor.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pg-change-password',
    templateUrl: './pg-change-password.component.html',
    styleUrls: ['./pg-change-password.component.scss'],
    standalone: false
})
export class PgChangePasswordComponent implements OnInit, OnDestroy {

    constructor(private pgProfileEditorService:PgProfileEditorService, private modalService:NgbModal, private authService:AuthService) { }

    @ViewChild('changePasswordTemplate') changePasswordTemplate: ElementRef;

    private _changePasswordModalRef:NgbModalRef = null;

    private _serviceSubscription:Subscription = null;

    ngOnInit(): void {

        this._serviceSubscription = this.pgProfileEditorService.request.subscribe((data) => {
            if(data.fn == 'change-password') {
                if(this._changePasswordModalRef == null) {
                    let _cOptions:NgbModalOptions = {
                        backdrop: 'static',
                        keyboard: false,
                        windowClass: 'PGChangePasswordModal',
                        size: 'md'
                    }
        
                    this._changePasswordModalRef = this.modalService.open(this.changePasswordTemplate, _cOptions);
                    this._changePasswordModalRef.result.then(() => {
                        this._changePasswordModalRef = null;
                    }, () => {
                        this._changePasswordModalRef = null;
                    })
                }

                this.changePasswordNew = '';
                this.changePasswordNewConfirm = '';
                this.onChangePasswordNewChange();
            }
        })
    }

    ngOnDestroy(): void {
        this._serviceSubscription.unsubscribe();
    }

    closeEditor() {
        this._changePasswordModalRef.close();
    }

    changePasswordNew = '';
    changePasswordNewConfirm = '';

    changePasswordErrorLength = false;
    changePasswordErrorFormat = false;
    changePasswordErrorConfirm = false;

    onChangePasswordNewChange() {
        this.changePasswordErrorLength = false;
        this.changePasswordErrorFormat = false;
        this.changePasswordErrorConfirm = false;

        if(this.changePasswordNew.length < 8) {
            this.changePasswordErrorLength = true;
        }
        else if(!/[a-z]/.test(this.changePasswordNew) || !/[A-Z]/.test(this.changePasswordNew) || !/\d/.test(this.changePasswordNew)) {
            this.changePasswordErrorFormat = true;
        }
        else if(this.changePasswordNew != this.changePasswordNewConfirm) {
            this.changePasswordErrorConfirm = true;
        }
    }

    canChangePassword() {
        return !this.changePasswordErrorLength && !this.changePasswordErrorFormat && !this.changePasswordErrorConfirm;
    }

    doChangePassword() {
        if(this.canChangePassword()) {
            this.authService.changePassword(this.changePasswordNew).then((data) => {
                if(data != null) {
                    this.closeEditor();
                    this.authService.logout();
                }
            }, () => {
            })
        }
    }

    onChangePasswordKeyUp(event:KeyboardEvent) {
        if(event.key == 'Enter') {
            this.doChangePassword();
        }
    }
}
